import { addDays } from "date-fns"

const VALID_THROUGH_YEAR = 2046
const REGULAR_BUSINESS_DAYS = [1, 2, 3, 4, 5] // 0 = Sunday
const EASTER_SUNDAY = {
  2026: new Date(2026, 3, 5),
  2027: new Date(2027, 2, 28),
  2028: new Date(2028, 3, 16),
  2029: new Date(2029, 3, 1),
  2030: new Date(2030, 3, 21),
  2031: new Date(2031, 3, 13),
  2032: new Date(2032, 2, 28),
  2033: new Date(2033, 3, 17),
  2034: new Date(2034, 3, 9),
  2035: new Date(2035, 2, 25),
  2036: new Date(2036, 3, 13),
  2037: new Date(2037, 3, 5),
  2038: new Date(2038, 3, 25),
  2039: new Date(2039, 3, 10),
  2040: new Date(2040, 3, 1),
  2041: new Date(2041, 3, 21),
  2042: new Date(2042, 3, 6),
  2043: new Date(2043, 2, 29),
  2044: new Date(2044, 3, 17),
  2045: new Date(2045, 3, 9),
  2046: new Date(2046, 2, 25),
}
const EASTER_OFFSETS = {
  GOOD_FRIDAY: -2,
  EASTER_MONDAY: 1,
  ASCENSION_DAY: 39,
  DAY_AFTER_ASCENSION: 40,
  WHIT_MONDAY: 50,
}
// Only counts as holiday once every 5 years
const LIBERATION_DAY = {
  2030: new Date(2030, 4, 5),
  2035: new Date(2035, 4, 5),
  2040: new Date(2040, 4, 5),
  2045: new Date(2045, 4, 5),
}

/**
 * Returns an array of holiday objects for the given year according to
 * Repowered's holiday rules. NOTE: Does not account for Sunday exception for
 * King's Day
 *
 * @param {number} year - The year for which to retrieve the holidays.
 * @returns {Array<{ reason: string, date: Date }>} An array of holiday objects.
 */
function getRepoweredHolidays(year) {
  if (year > VALID_THROUGH_YEAR) {
    throw new Error(`Can't handle years beyond ${VALID_THROUGH_YEAR}`)
  }

  const easterSunday = EASTER_SUNDAY[year]
  return [
    { reason: "Nieuwjaarsdag", date: new Date(year, 0, 1) },
    {
      reason: "Goede Vrijdag",
      date: addDays(easterSunday, EASTER_OFFSETS.GOOD_FRIDAY),
    },
    {
      reason: "tweede Paasdag",
      date: addDays(easterSunday, EASTER_OFFSETS.EASTER_MONDAY),
    },
    { reason: "Koningsdag", date: new Date(year, 3, 27) },
    { reason: "Bevrijdingsdag", date: LIBERATION_DAY[year] },
    {
      reason: "Hemelvaartsdag",
      date: addDays(easterSunday, EASTER_OFFSETS.ASCENSION_DAY),
    },
    {
      reason: "de dag na Hemelvaart",
      date: addDays(easterSunday, EASTER_OFFSETS.DAY_AFTER_ASCENSION),
    },
    {
      reason: "tweede Pinksterdag",
      date: addDays(easterSunday, EASTER_OFFSETS.WHIT_MONDAY),
    },
    { reason: "eerste Kerstdag", date: new Date(year, 11, 25) },
    { reason: "tweede Kerstdag", date: new Date(year, 11, 26) },
  ].filter((holiday) => holiday.date) // Remove undefined entries
}

/**
 * Adds the specified number of business days to the given date, taking into
 * account Repowered holidays and weekends.
 *
 * @param {Date} date - The starting date.
 * @param {number} businessDays - The number of business days to add.
 * @returns {{ date: Date, holidays: string[] }} An object containing the
 * resulting date and the holidays encountered.
 */
export default function addBusinessDays(date, businessDays) {
  let newDate = new Date(date)
  const holidays = []
  while (businessDays > 0) {
    newDate = addDays(newDate, 1)
    const regularBusinessDay = REGULAR_BUSINESS_DAYS.includes(newDate.getDay())
    const holiday = getRepoweredHolidays(newDate.getFullYear()).find(
      (h) => h.date.toDateString() === newDate.toDateString(),
    )
    if (regularBusinessDay) {
      if (!holiday) {
        businessDays--
      } else {
        holidays.push(holiday.reason)
      }
    }
  }
  return { date: newDate, holidays }
}
